import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Link,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import SuccessGif from 'assets/gifs/success.gif';
import { META } from 'common/constants';
import { PrimaryButton } from 'components/lib/PrimaryButton';
import type { FC } from 'react';
import { EligibilityResultWrapperAgreementTextStyle } from './EligibilityResultWrapper.styles';
import type { EligibilityResultWrapperProps } from './EligibilityResultWrapper.types';

const EligibilityResultWrapper: FC<EligibilityResultWrapperProps> = ({
  formDisabled = false,
  actionButtonText,
  formik,
  result,
  subtitle,
  title,
}) => {
  const isSuccess = result === 'success';

  const onSubmit: typeof formik.handleSubmit = (event) => {
    formik.handleSubmit(event);
  };

  return (
    <>
      <Box sx={{ mb: 6 }}>
        {isSuccess && (
          <Box
            component="img"
            src={SuccessGif}
            alt="SuccessGif"
            sx={{
              maxWidth: (theme) => theme.spacing(10),
            }}
          />
        )}

        <Typography
          variant="h1"
          sx={{
            mb: 1,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            mb: 2,
          }}
        >
          {subtitle}
        </Typography>

        <form
          id="checkEligibilityResultForm"
          name="checkEligibilityResultForm"
          noValidate
          onSubmit={onSubmit}
        >
          <Stack display="flex" flex-direction="column" gap={3}>
            <FormControl variant="standard" fullWidth>
              <TextField
                id="email"
                name="email"
                label="Email"
                value={formik.values.email}
                type="email"
                onChange={(event) => formik.setFieldValue('email', event.target.value)}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched?.email && formik.errors?.email}
                disabled={formDisabled}
                slotProps={{
                  htmlInput: {
                    autoComplete: 'off',
                    'data-test': 'email',
                  },
                }}
              />
            </FormControl>

            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    value={formik.values.subscribeOnMailing}
                    disabled={formDisabled}
                    onChange={(event) =>
                      formik.setFieldValue('subscribeOnMailing', event.target.checked)
                    }
                  />
                }
                label="Send me news and updates about THREE"
                slotProps={{
                  typography: {
                    variant: 'body2',
                  },
                }}
              />
            </FormControl>
          </Stack>
        </form>
      </Box>
      <Stack
        sx={{
          textAlign: 'center',
        }}
        gap={2}
      >
        <PrimaryButton
          text={actionButtonText}
          fullWidth
          type="submit"
          data-test="check-eligibility"
          form="checkEligibilityResultForm"
          sx={{ mt: 2 }}
          disabled={formDisabled}
        />

        <Typography variant="body2" sx={EligibilityResultWrapperAgreementTextStyle}>
          By clicking “{actionButtonText}” you agree that you have read and acknowledged our{' '}
          <Link href={META.PRIVACY_POLICY_LINK} target="_blank">
            Privacy Statement
          </Link>
        </Typography>
      </Stack>
    </>
  );
};

export default EligibilityResultWrapper;
